import React from 'react';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { LiabilityEntityIndex } from '@funnels/types';
import { validateCreditLimitGreaterThanOrEqualToCurrentBalance } from '@funnels/utils';

import { DollarInputField, NumeralDisplay } from '../../Fields';
import { NumericalInputFieldProps } from '../../Fields/NumericalInputField';
import { EditableViewProps, NumericalReadOnlyViewProps } from '../types';

interface LiabilityCreditLimitFunnelViewProps extends LiabilityEntityIndex, Omit<NumericalInputFieldProps, 'name'> {
  label?: string;
}
export function LiabilityCreditLimitFunnelView(props: LiabilityCreditLimitFunnelViewProps) {
  const { liabilityIndex, label = 'What is the credit limit on this card?' } = props;
  const [formValues] = useFormValues();
  const currentBalance = get(formValues, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(liabilityIndex));

  return (
    <DollarInputField
      isZeroValid
      {...props}
      label={label}
      name={FIELD_PATHS.LIABILITY_CREDIT_LIMIT(liabilityIndex)}
      validate={validateCreditLimitGreaterThanOrEqualToCurrentBalance(
        props.validationFailMessage || 'Limit must be equal to or greater than current balance',
        currentBalance,
        props.isOptional
      )}
    />
  );
}

interface LiabilityCreditLimitEditableViewProps
  extends EditableViewProps,
    LiabilityEntityIndex,
    Omit<NumericalInputFieldProps, 'name'> {}

export function LiabilityCreditLimitEditableView(props: LiabilityCreditLimitEditableViewProps) {
  const { liabilityIndex, validationFailMessage, ...rest } = props;
  const [formValues] = useFormValues();
  const currentBalance = get(formValues, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(liabilityIndex), 0);

  return (
    <DollarInputField
      {...rest}
      key={`limit-current-balance-${currentBalance}`}
      name={FIELD_PATHS.LIABILITY_CREDIT_LIMIT(liabilityIndex)}
      isZeroValid={true}
      validate={validateCreditLimitGreaterThanOrEqualToCurrentBalance(
        validationFailMessage || 'Limit must be equal to or greater than current balance',
        currentBalance,
        props.isOptional
      )}
    />
  );
}

export const LiabilityCreditLimitReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay before={'$'} {...props} />
);
